import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface GetOrderListSelectionDetail {
  orderBranchCode: SystemCode
  orderNumber: number
  holdingNumber: number
  orderingNumber: number
  mark: string
  ndc: string
  book: string
  sub: string
  traderEnvVendorId: number
  donorEnvVendorId: number
  departmentCode: SystemCode
  budgetYear: string
  budgetBranchCode: SystemCode
  budgetDepartmentCode: SystemCode
  budgetItem: string
  equipType: SystemCode
  acceptType: SystemCode
  collectionType: SystemCode
  appendixCode: SystemCode
  shelfType: SystemCode
  handlingType: SystemCode
  revision: number
}

export function GetOrderListSelectionDetailFromJSON(
  json: any
): GetOrderListSelectionDetail {
  return {
    orderBranchCode: exists(json, 'order_branch_code')
      ? SystemCodeFromJSON(json.order_branch_code)
      : defaultSystemCode(),
    orderNumber: exists(json, 'order_number') ? json.order_number : 0,
    holdingNumber: exists(json, 'holding_number') ? json.holding_number : 0,
    orderingNumber: exists(json, 'ordering_number') ? json.ordering_number : 0,
    mark: exists(json, 'mark') ? json.mark : '',
    ndc: exists(json, 'ndc') ? json.ndc : '',
    book: exists(json, 'book') ? json.book : '',
    sub: exists(json, 'sub') ? json.sub : '',
    traderEnvVendorId: exists(json, 'trader_env_vendor_id')
      ? json.trader_env_vendor_id
      : 0,
    donorEnvVendorId: exists(json, 'donor_env_vendor_id')
      ? json.donor_env_vendor_id
      : 0,
    departmentCode: exists(json, 'department_code')
      ? SystemCodeFromJSON(json.department_code)
      : defaultSystemCode(),
    budgetYear: exists(json, 'budget_year') ? json.budget_year : '',
    budgetBranchCode: exists(json, 'budget_branch_code')
      ? SystemCodeFromJSON(json.budget_branch_code)
      : defaultSystemCode(),
    budgetDepartmentCode: exists(json, 'budget_department_code')
      ? SystemCodeFromJSON(json.budget_department_code)
      : defaultSystemCode(),
    budgetItem: exists(json, 'budget_item') ? json.budget_item : '',
    equipType: exists(json, 'equip_type')
      ? SystemCodeFromJSON(json.equip_type)
      : defaultSystemCode(),
    acceptType: exists(json, 'accept_type')
      ? SystemCodeFromJSON(json.accept_type)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    appendixCode: exists(json, 'appendix_code')
      ? SystemCodeFromJSON(json.appendix_code)
      : defaultSystemCode(),
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
